import type { ReactElement } from 'react'
import type { TFunction } from 'i18next'
import { ExportTemplateButton } from '../../../components/infrastructure/ExportTemplateButton'
import type { ColumnDefinition } from './case-infrastructure-tab.helpers'
import {
  AddEndpointButton,
  ColumnSettings,
  ImportDropdown,
  RefreshButton,
  TitleSection,
} from './case-infrastructure-tab-header/case-infrastructure-tab-header.parts'

export interface CaseInfrastructureTabHeaderProps {
  caseId: string
  t: TFunction<'cases'>
  endpointsCount: number
  relationshipsCount: number
  viewMode: 'list' | 'map'
  setViewMode: (mode: 'list' | 'map') => void
  refetch: () => unknown
  showColumnSettings: boolean
  setShowColumnSettings: (v: boolean | ((prev: boolean) => boolean)) => void
  visibleColumns: Set<string>
  toggleColumn: (id: string) => void
  resetColumns: () => void
  columnDefinitions: ColumnDefinition[]
  showImportDropdown: boolean
  setShowImportDropdown: (v: boolean | ((prev: boolean) => boolean)) => void
  setShowNewImportModal: (v: boolean) => void
  setShowRelationshipImportModal: (v: boolean) => void
  setShowCsvImportModal: (v: boolean) => void
  setShowJsonImportModal: (v: boolean) => void
  setShowCreateModal: (v: boolean) => void
}

export function CaseInfrastructureTabHeader(props: CaseInfrastructureTabHeaderProps): ReactElement {
  const importActions = {
    setShowNewImportModal: props.setShowNewImportModal,
    setShowRelationshipImportModal: props.setShowRelationshipImportModal,
    setShowCsvImportModal: props.setShowCsvImportModal,
    setShowJsonImportModal: props.setShowJsonImportModal,
  }
  return (
    <div className="flex items-center justify-between">
      <TitleSection
        endpointsCount={props.endpointsCount}
        relationshipsCount={props.relationshipsCount}
        viewMode={props.viewMode}
        setViewMode={props.setViewMode}
        t={props.t}
      />
      <div className="flex items-center gap-3">
        <RefreshButton refetch={props.refetch} t={props.t} />
        <ColumnSettings
          showColumnSettings={props.showColumnSettings}
          setShowColumnSettings={props.setShowColumnSettings}
          visibleColumns={props.visibleColumns}
          toggleColumn={props.toggleColumn}
          resetColumns={props.resetColumns}
          columnDefinitions={props.columnDefinitions}
          t={props.t}
        />
        <ExportTemplateButton caseId={props.caseId} />
        <ImportDropdown
          showImportDropdown={props.showImportDropdown}
          setShowImportDropdown={props.setShowImportDropdown}
          actions={importActions}
          t={props.t}
        />
        <AddEndpointButton setShowCreateModal={props.setShowCreateModal} t={props.t} />
      </div>
    </div>
  )
}
